import $ from 'jquery';
import Modal from 'bootstrap/js/src/modal';

const SURVEY_STORAGE_KEY = 'survey-submissions';
const SURVEY_ALREADY_SENT_MESSAGE = 'Du hast diese Umfrage bereits gesendet.';

const showSurveyAlert = (title, details) => {
  const modal = document.getElementById('alert-modal');
  if (modal) {
    const titleEl = modal.querySelector('#alert-title');
    const detailEl = modal.querySelector('#alert-details');
    if (titleEl) titleEl.textContent = title || '';
    if (detailEl) detailEl.textContent = details || '';

    (Modal.getInstance(modal) || new Modal(modal)).show();
    return;
  }

  if (title || details) {
    window.alert([title, details].filter(Boolean).join('\n'));
  }
};

const safeReadLocalStorage = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (_e) {
    return null;
  }
};

const readJsonFromLocalStorage = (key) => {
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
};

const writeJsonToLocalStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (_e) {
    // ignore storage errors (quota / private mode)
  }
};

const submissionStorageKey = (uuid, tokenIdentifier) => {
  const tokenPart = (tokenIdentifier || 'anonymous').toString().trim() || 'anonymous';
  return `${(uuid || 'unknown').toString().trim()}::${tokenPart}`;
};

const storeSurveySubmission = (uuid, tokenIdentifier, responses, meta = {}) => {
  if (!uuid || !responses) {
    return;
  }
  const store = readJsonFromLocalStorage(SURVEY_STORAGE_KEY) || {};
  store[submissionStorageKey(uuid, tokenIdentifier)] = {
    uuid,
    tokenIdentifier,
    responses,
    authenticityToken: meta.authenticityToken,
    submittedAt: new Date().toISOString(),
  };
  writeJsonToLocalStorage(SURVEY_STORAGE_KEY, store);
};

const readStoredSurveySubmission = (uuid, tokenIdentifier) => {
  if (!uuid) {
    return null;
  }
  const store = readJsonFromLocalStorage(SURVEY_STORAGE_KEY) || {};
  return store[submissionStorageKey(uuid, tokenIdentifier)];
};

const getCsrfToken = () => {
  const el = document.querySelector('meta[name="csrf-token"]');
  return el ? el.getAttribute('content') : null;
};

const getAuthenticityTokenFromForm = (form) => {
  const token = form && form.querySelector
    ? (form.querySelector('input[name="authenticity_token"]') || {}).value
    : null;
  if (token) {
    return token.toString().trim();
  }
  return getCsrfToken();
};

const getPushTokenFromForm = (form) => {
  const tokenSources = [
    form && form.dataset ? form.dataset.pushToken : null,
    form && form.querySelector ? (form.querySelector('input[name="pushtoken"]') || {}).value : null,
    form && form.querySelector ? (form.querySelector('input[name="token"]') || {}).value : null,
    safeReadLocalStorage('email-sub-token'),
    safeReadLocalStorage('pushtoken'),
    safeReadLocalStorage('push-token'),
  ];

  const found = tokenSources.find((entry) => entry && entry.toString().trim().length > 0);
  return found ? found.toString().trim() : null;
};

const getStorageTokenIdentifier = (form) => {
  const pushToken = getPushTokenFromForm(form);
  return pushToken || getAuthenticityTokenFromForm(form) || 'anonymous';
};

const getSurveyUuid = (form) => {
  const valueFromInput = form && form.querySelector ? (form.querySelector('input[name="uuid"]') || {}).value : null;
  const value = valueFromInput || (form && form.dataset ? form.dataset.surveyUuid : null);
  return value ? value.toString().trim() : null;
};

const collectSectionValue = ($card, type) => {
  if (type === 'ranking') {
    return $card.find('.ranking-input').map(function rankVal() { return $(this).val(); }).get();
  }

  if (type === 'likert' || type === 'matrix') {
    const result = {};
    $card.find(':input[name^="responses["]').not('[type="hidden"]').each(function collectRow() {
      const $input = $(this);
      if ($input.prop('checked')) {
        const match = ($input.attr('name') || '').match(/\[([^\]]+)\]\[([^\]]+)\]$/);
        if (match) result[match[2]] = $input.val();
      }
    });
    return Object.keys(result).length > 0 ? result : null;
  }

  const isMulti = type === 'multiple-multi' || type === 'multiple-select';
  const values = [];

  $card.find(':input[name^="responses["]').not('[type="hidden"]').each(function collectVal() {
    const $input = $(this);
    const inputType = ($input.attr('type') || '').toLowerCase();
    if (inputType === 'radio' || inputType === 'checkbox') {
      if ($input.prop('checked')) values.push($input.val());
    } else {
      const v = ($input.val() || '').toString().trim();
      if (v !== '') values.push(v);
    }
  });

  if (isMulti) return values;
  return values.length > 0 ? values[0] : null;
};

const buildSurveyResponses = ($form) => {
  const responses = {};
  $form.find('.section-card').each(function buildSection() {
    const $card = $(this);
    const index = $card.data('index');
    const type = ($card.find('.question-card').first().data('type') || '').toString();
    const question = $card.find('.question-title').first().text().trim();
    const value = collectSectionValue($card, type);
    if (index !== undefined && index !== null && index !== '') {
      responses[`q_${index}`] = { question, type, value };
    }
  });
  return responses;
};

const collectResponsesForStorage = (form) => {
  const data = {};
  const formData = new FormData(form);

  formData.forEach((value, key) => {
    if (!key.startsWith('responses[')) {
      return;
    }

    if (data[key] !== undefined) {
      data[key] = Array.isArray(data[key]) ? data[key] : [data[key]];
      data[key].push(value);
    } else {
      data[key] = value;
    }
  });

  return data;
};

const setStatusMessage = ($form, message, tone = 'info') => {
  const $status = $form.find('[data-survey-status]').first();
  if (!$status.length) {
    return;
  }

  $status.removeClass('status-info status-success status-error');
  if (message) {
    $status.text(message);
    $status.addClass(`status-${tone}`);
    $status.show();
  } else {
    $status.text('');
    $status.hide();
  }
};

const hideInlineAlert = ($form) => {
  const $alert = $form.find('[data-survey-inline-alert]').first();
  if (!$alert.length) {
    return;
  }

  $alert.addClass('d-none');
  $alert.removeClass('alert-success alert-danger alert-info alert-warning');
  $alert.text('');
};

const showInlineAlert = ($form, message, tone = 'success', title = null) => {
  const $alert = $form.find('[data-survey-inline-alert]').first();
  if (!$alert.length) {
    return;
  }

  const toneClass = {
    success: 'alert-success',
    error: 'alert-danger',
    info: 'alert-info',
    warning: 'alert-warning',
  }[tone] || 'alert-info';

  $alert.removeClass('d-none alert-success alert-danger alert-info alert-warning');
  $alert.addClass(`alert ${toneClass}`);

  if (title) {
    const $title = $('<strong class="sv-alert-title"></strong>').text(title);
    const $body = $('<p class="sv-alert-body mb-0"></p>').text(message || '');
    $alert.empty().append($title).append($body);
  } else {
    $alert.empty().append($('<p class="sv-alert-body mb-0"></p>').text(message || ''));
  }
};

const scrollToInlineAlert = ($form) => {
  const alertEl = $form.find('[data-survey-inline-alert]').first().get(0);
  if (!alertEl) {
    return;
  }

  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

const scrollToVisibleInlineAlert = () => {
  const alertEl = document.querySelector('[data-survey-inline-alert]:not(.d-none)');
  if (!alertEl) {
    return;
  }
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

const scheduleScrollToVisibleAlert = () => {
  window.requestAnimationFrame(() => {
    setTimeout(scrollToVisibleInlineAlert, 50);
  });
};

const setSubmitButtonLoading = ($form, isLoading) => {
  const $btn = $form.find('.submit-btn');
  if (!$btn.length) {
    return;
  }

  if (!$btn.data('original-text')) {
    $btn.data('original-text', $btn.html());
  }

  if (isLoading) {
    $btn.prop('disabled', true).addClass('is-disabled');
    $btn.html('<span class="spinner-border spinner-border-sm text-white" role="status" aria-hidden="true"></span>');
  } else {
    $btn.html($btn.data('original-text') || 'Absenden');
  }
};

const markFormAsSubmitted = ($form) => {
  $form.find('.submit-btn').prop('disabled', true).addClass('is-disabled');
  $form.find(':input').not('.submit-btn').prop('disabled', true);
  $form.find('.survey-page').addClass('is-submitted');
};

const restoreSubmitButton = ($form) => {
  const $btn = $form.find('.submit-btn');
  if (!$btn.length) {
    return;
  }

  const originalText = $btn.data('original-text') || 'Absenden';
  $btn.html(originalText);
  $btn.prop('disabled', false).removeClass('is-disabled');
};

const updateNpsSelection = ($scale, value) => {
  $scale.find('.nps-number').each(function updateNumber() {
    const score = parseInt($(this).data('score'), 10);
    $(this).toggleClass('selected', score <= value);
  });
};

const initNpsScale = () => {
  $('.nps-scale').each(function prepareNps() {
    const $scale = $(this);
    $scale.off('change.survey').on('change.survey', '.nps-input', function onChange() {
      const value = parseInt($(this).val(), 10);
      updateNpsSelection($scale, value);
    });

    const $checked = $scale.find('.nps-input:checked').first();
    if ($checked.length) {
      $checked.trigger('change');
    }
  });
};

const setStarValue = ($rating, value) => {
  const $input = $rating.find('.star-rating-input');
  $input.val(value).trigger('change');
  $rating.find('.star').each(function toggleStar() {
    const starValue = parseInt($(this).data('value'), 10);
    $(this).toggleClass('filled', starValue <= value);
  });
};

const initStars = () => {
  $('.star-rating').each(function prepareStars() {
    const $rating = $(this);
    $rating.off('click.survey').on('click.survey', '.star', function onClick() {
      const value = parseInt($(this).data('value'), 10);
      setStarValue($rating, value);
    });

    const preset = parseInt($rating.find('.star-rating-input').val(), 10);
    if (preset) {
      setStarValue($rating, preset);
    }
  });
};

const initEmojis = () => {
  $('.emoji-rating').each(function prepareEmoji() {
    const $rating = $(this);
    $rating.off('change.survey').on('change.survey', '.emoji-input', function onChange() {
      $rating.find('.emoji').removeClass('selected');
      $(this).closest('.emoji').addClass('selected');
    });

    const $checked = $rating.find('.emoji-input:checked').first();
    if ($checked.length) {
      $checked.trigger('change');
    }
  });
};

const formatNumber = (value) =>
  Number(value).toLocaleString('de-DE', { maximumFractionDigits: 0 });

const initSliders = () => {
  $('.slider-container').each(function prepareSlider() {
    const $container = $(this);
    $container.addClass('slider-shell');

    const $value = $container.find('.slider-value');
    const $input = $container.find('.slider');

    if (!$input.length || !$value.length) {
      return;
    }

    // Build structure so we can mimic the React Native slider layout without touching HAML.
    let $badgeWrap = $container.find('.slider-progress-badge-wrap').first();
    if (!$badgeWrap.length) {
      $badgeWrap = $(`
        <div class="slider-progress-badge-wrap" aria-hidden="true">
          <div class="slider-progress-badge">
            <span class="slider-progress-badge-text"></span>
          </div>
          <div class="slider-progress-badge-pointer"></div>
        </div>
      `.trim());
    }

    let $railArea = $container.find('.slider-rail-area').first();
    if (!$railArea.length) {
      $railArea = $('<div class="slider-rail-area"></div>');
      // Put the rail area above the numeric value.
      $railArea.insertBefore($value);
    }

    // Badge should be positioned relative to the rail area (not the outer shell padding).
    if (!$badgeWrap.parent().is($railArea)) {
      $railArea.prepend($badgeWrap);
    }

    let $controlWrap = $railArea.find('.slider-control-wrap').first();
    if (!$controlWrap.length) {
      $controlWrap = $('<div class="slider-control-wrap"></div>');
      $railArea.append($controlWrap);
    }

    // Move input inside the control wrap (keeps submitted name/value).
    if (!$input.parent().is($controlWrap)) {
      $input.appendTo($controlWrap);
    }

    let $trackRow = $controlWrap.find('.slider-track-row').first();
    if (!$trackRow.length) {
      $trackRow = $(`
        <div class="slider-track-row" aria-hidden="true">
          <div class="slider-track-filled"></div>
          <div class="slider-track-empty"></div>
        </div>
      `.trim());
      $controlWrap.prepend($trackRow);
    }

    const $trackFilled = $trackRow.find('.slider-track-filled');
    const $trackEmpty = $trackRow.find('.slider-track-empty');

    let $scale = $container.find('.slider-scale').first();
    if (!$scale.length) {
      $scale = $(`
        <div class="slider-scale" aria-hidden="true">
          <span class="slider-scale-min"></span>
          <span class="slider-scale-max"></span>
        </div>
      `.trim());
      $container.append($scale);
    }

    const prefix = $container.data('prefix') || '';
    const suffix = $container.data('suffix') || '';
    const getNumericAttr = (name, fallback) => {
      const raw = $input.attr(name);
      const parsed = raw !== undefined && raw !== null && raw !== '' ? Number(raw) : Number.NaN;
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const min = getNumericAttr('min', 0);
    const max = getNumericAttr('max', 100);
    $scale.find('.slider-scale-min').text(formatNumber(min));
    $scale.find('.slider-scale-max').text(formatNumber(max));

    const THUMB_SIZE_PX = 28; // keep in sync with SCSS (.slider::-*-thumb)

    const clampToRange = (val) => {
      const numeric = Number(val);
      return Number.isFinite(numeric) ? Math.min(Math.max(numeric, min), max) : min;
    };

    const percentageFor = (val) => {
      const denom = (max - min);
      const clamped = clampToRange(val);
      return denom > 0 ? ((clamped - min) / denom) * 100 : 0;
    };

    const setTrackAndBadge = (pct) => {
      const inputEl = $input.get(0);
      if (!inputEl) {
        return;
      }

      const width = Math.max(inputEl.getBoundingClientRect().width, 1);
      const usable = Math.max(width - THUMB_SIZE_PX, 1);
      const thumbCenterPx = (pct / 100) * usable + (THUMB_SIZE_PX / 2);
      // Track fill should hit the extremes exactly:
      // - 0% => 0px
      // - 100% => full width
      // In between, fill up to the thumb center (RN-style).
      const fillPx =
        pct <= 0 ? 0
          : pct >= 100 ? width
            : thumbCenterPx;
      const fillPct = (fillPx / width) * 100;

      $trackFilled.css('width', `${fillPct}%`);
      $trackEmpty.css('width', `${Math.max(0, 100 - fillPct)}%`);

      $badgeWrap.css('left', `${thumbCenterPx}px`);
      $badgeWrap.find('.slider-progress-badge-text').text(`${Math.round(pct)}%`);
    };

    const update = (val) => {
      $value.text(`${prefix}${formatNumber(val)}${suffix}`);
      const pct = percentageFor(val);
      setTrackAndBadge(pct);
    };

    $input.off('input.survey change.survey')
      .on('input.survey change.survey', function onSlide() {
        update($(this).val());
      });

    // Initial render + reflow after layout (fonts / responsive container).
    update($input.val());
    window.requestAnimationFrame(() => update($input.val()));
  });
};

const updateRankingNumbers = ($list) => {
  $list.find('.ranking-item').each(function updateIndex(index) {
    $(this).find('.ranking-number').text(index + 1);
  });
};

const restoreRankingOrder = (form, responses) => {
  $(form).find('.ranking-list').each(function restoreList() {
    const $list = $(this);
    const $sampleInput = $list.find('.ranking-input').first();
    if (!$sampleInput.length) {
      return;
    }

    const name = $sampleInput.attr('name');
    const savedOrder = responses[name];
    if (!savedOrder) {
      return;
    }

    const values = Array.isArray(savedOrder) ? savedOrder : [savedOrder];
    values.forEach((value) => {
      const $item = $list.find('.ranking-item').filter(function findItem() {
        const $input = $(this).find('.ranking-input').first();
        return $input.length && $input.val() === value;
      }).first();

      if ($item.length) {
        $item.appendTo($list);
      }
    });

    updateRankingNumbers($list);
  });
};

const initRanking = () => {
  $('.ranking-list').each(function prepareRanking() {
    const list = this;
    const $list = $(this);
    let dragging = null;
    let ghost = null;
    let grabOffsetY = 0;
    let grabOffsetX = 0;

    const moveGhost = (clientX, clientY) => {
      if (!ghost) return;
      ghost.style.top = `${clientY - grabOffsetY}px`;
      ghost.style.left = `${clientX - grabOffsetX}px`;
    };

    const reorder = (clientY) => {
      const siblings = [...list.querySelectorAll('.ranking-item:not(.is-placeholder)')];
      let inserted = false;
      for (const sibling of siblings) {
        const { top, height } = sibling.getBoundingClientRect();
        if (clientY < top + height / 2) {
          list.insertBefore(dragging, sibling);
          inserted = true;
          break;
        }
      }
      if (!inserted) list.appendChild(dragging);
    };

    list.addEventListener('pointerdown', (e) => {
      const item = e.target.closest('.ranking-item');
      if (!item || !list.contains(item)) return;

      e.preventDefault();
      dragging = item;

      const rect = item.getBoundingClientRect();
      grabOffsetX = e.clientX - rect.left;
      grabOffsetY = e.clientY - rect.top;

      // Build ghost clone that floats above the list
      ghost = item.cloneNode(true);
      ghost.className = 'ranking-ghost';
      ghost.style.width = `${rect.width}px`;
      ghost.style.height = `${rect.height}px`;
      document.body.appendChild(ghost);
      moveGhost(e.clientX, e.clientY);

      // Original item becomes a size-preserving placeholder
      item.classList.add('is-placeholder');

      list.setPointerCapture(e.pointerId);
    });

    list.addEventListener('pointermove', (e) => {
      if (!dragging) return;
      moveGhost(e.clientX, e.clientY);
      reorder(e.clientY);
    });

    const endDrag = (e) => {
      if (!dragging) return;
      dragging.classList.remove('is-placeholder');
      if (ghost) { ghost.remove(); ghost = null; }
      dragging = null;
      updateRankingNumbers($list);
    };

    list.addEventListener('pointerup', endDrag);
    list.addEventListener('pointercancel', endDrag);
  });
};

const initImageOptions = () => {
  $('.image-options').each(function prepareImages() {
    const $group = $(this);

    const applySelected = () => {
      $group.find('.image-option').removeClass('selected');
      $group.find('.image-option-input:checked').each(function toggleSelected() {
        $(this).closest('.image-option').addClass('selected');
      });

      $group.find('.image-option').each(function syncAria() {
        const $option = $(this);
        const isChecked = $option.find('.image-option-input').prop('checked');
        $option.attr('aria-checked', isChecked ? 'true' : 'false');
      });
    };

    $group.off('change.imageOptions')
      .on('change.imageOptions', '.image-option-input', () => applySelected());

    const selectOption = ($option) => {
      const $input = $option.find('.image-option-input');
      if (!$input.length) {
        return;
      }

      if (!$input.prop('checked')) {
        $input.prop('checked', true).trigger('change');
      } else {
        applySelected();
      }
    };

    $group.off('click.imageOptions')
      .on('click.imageOptions', '.image-option', function onClick(event) {
        const $target = $(event.target);
        if ($target.is(':input')) {
          return;
        }

        event.preventDefault();
        selectOption($(this));
      });

    $group.off('keydown.imageOptions')
      .on('keydown.imageOptions', '.image-option', function onKeyDown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectOption($(this));
        }
      });

    if (!$group.find('.image-option-input:checked').length) {
      const $first = $group.find('.image-option-input').first();
      if ($first.length) {
        $first.prop('checked', true);
      }
    }

    applySelected();
  });
};

const toggleInputState = ($input) => {
  if (!$input.length || $input.prop('disabled')) {
    return;
  }

  const type = ($input.attr('type') || '').toLowerCase();
  if (type === 'checkbox') {
    $input.prop('checked', !$input.prop('checked'));
  } else if (type === 'radio') {
    if ($input.prop('checked')) {
      return;
    }
    $input.prop('checked', true);
  } else {
    return;
  }

  $input.trigger('change');
  $input.trigger('input');
  $input.trigger('focus');
};

const shouldSkipWrapperClick = (event, extraSkipSelectors = []) => {
  const baseSelectors = [':input', 'a', 'button'];
  const extras = Array.isArray(extraSkipSelectors) ? extraSkipSelectors : [extraSkipSelectors];
  const selectors = baseSelectors.concat(extras.filter(Boolean));
  return selectors.length > 0 && $(event.target).closest(selectors.join(', ')).length > 0;
};

const bindWrapperInputToggle = ({
  namespace,
  wrapperSelector,
  inputSelector,
  extraSkipSelectors = [],
}) => {
  if (!wrapperSelector || !inputSelector) {
    return;
  }

  const eventName = namespace ? `click.${namespace}` : 'click';
  $('.survey-page')
    .off(eventName)
    .on(eventName, wrapperSelector, function handleWrapperClick(event) {
      if (shouldSkipWrapperClick(event, extraSkipSelectors)) {
        return;
      }

      const $wrapper = $(this);
      const $input = typeof inputSelector === 'function'
        ? inputSelector($wrapper, event)
        : $wrapper.find(inputSelector).first();

      if (!$input.length) {
        return;
      }

      event.preventDefault();
      toggleInputState($input);
    });
};

const initChoiceOptionClicks = () => bindWrapperInputToggle({
  namespace: 'choiceOption',
  wrapperSelector: '.option',
  inputSelector: 'input[type="radio"], input[type="checkbox"]',
});

const initMatrixSelections = () => bindWrapperInputToggle({
  namespace: 'matrixCell',
  wrapperSelector: '.matrix-table td',
  inputSelector: 'input[type="radio"], input[type="checkbox"]',
});

const initNpsSelections = () => bindWrapperInputToggle({
  namespace: 'npsNumber',
  wrapperSelector: '.nps-number',
  inputSelector: '.nps-input',
});

const initEmojiSelections = () => bindWrapperInputToggle({
  namespace: 'emojiOption',
  wrapperSelector: '.emoji',
  inputSelector: '.emoji-input',
});

const applySavedResponses = (form, responses) => {
  if (!form || !responses) {
    return;
  }

  const elements = form.querySelectorAll('[name^="responses["]');
  elements.forEach((element) => {
    const savedValue = responses[element.name];
    if (savedValue === undefined) {
      return;
    }

    const type = (element.type || '').toLowerCase();
    if (type === 'hidden') {
      return;
    }

    const normalized = Array.isArray(savedValue) ? savedValue.map((v) => v.toString()) : [savedValue.toString()];

    if (type === 'radio') {
      element.checked = normalized.includes(element.value);
    } else if (type === 'checkbox') {
      element.checked = normalized.includes(element.value);
    } else {
      const firstValue = Array.isArray(savedValue) ? savedValue[0] : savedValue;
      if (firstValue !== undefined && firstValue !== null) {
        element.value = firstValue;
      }
    }

    ['change', 'input'].forEach((eventName) => {
      const ev = new Event(eventName, { bubbles: true });
      element.dispatchEvent(ev);
    });
  });

  restoreRankingOrder(form, responses);
};

const sectionHasValue = ($section) => {
  // Ranking: always considered answered (items always have an order)
  if ($section.find('.ranking-list').length) {
    return $section.find('.ranking-input').length > 0;
  }

  let filled = false;

  $section.find(':input').not('[type="hidden"]').not('button').each(function checkInput() {
    const $input = $(this);
    const type = ($input.attr('type') || '').toLowerCase();

    if ((type === 'radio' || type === 'checkbox') && $input.prop('checked')) {
      filled = true;
      return false;
    }

    if (type !== 'radio' && type !== 'checkbox' && ($input.val() || '').toString().trim() !== '') {
      filled = true;
      return false;
    }
  });

  return filled;
};

const validateRequiredSections = ($form) => {
  const $required = $form.find('.section-card[data-required="true"]');
  const invalid = [];

  $required.each(function inspectSection() {
    const $section = $(this);
    if (sectionHasValue($section)) {
      $section.removeClass('is-invalid');
    } else {
      $section.addClass('is-invalid');
      invalid.push($section);
    }
  });

  return invalid;
};

const scrollToFirstInvalidSection = ($form) => {
  const target = $form.find('.section-card.is-invalid').first().get(0);
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};

const scrollToPrerenderedErrors = () => {
  // Scroll to first section that the server already flagged (highlight_error: true)
  const target = document.querySelector('.survey-page .section-card.is-invalid');
  if (target) {
    window.requestAnimationFrame(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
};

const initClientValidation = () => {
  // Bind to the form submit event — runs before handleSurveySubmit (same event, bound first).
  // Using submit rather than button click avoids issues with disabled-button pointer-events.
  $('.survey-page').closest('form').each(function attachValidation() {
    const $form = $(this);

    $form.off('submit.surveyValidation').on('submit.surveyValidation', function onFormSubmit(event) {
      if ($form.data('surveySubmitted')) {
        return;
      }

      const invalid = validateRequiredSections($form);

      if (invalid.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        scrollToFirstInvalidSection($form);
      }
    });
  });
};

// ─── Progress bar ─────────────────────────────────────────────────────────────
const updateProgressBar = ($form, percent, instant = false) => {
  const $bar = $form.find('[data-survey-progress-bar]');
  const $label = $form.find('[data-survey-progress-label]');
  if (!$bar.length) return;

  const pct = Math.min(100, Math.max(0, Math.round(percent)));

  if (instant) {
    $bar.css('transition', 'none');
    // Force reflow so the transition removal applies before the width change
    // eslint-disable-next-line no-unused-expressions
    $bar.get(0).offsetHeight;
  }

  $bar.css('width', `${pct}%`).attr('aria-valuenow', pct);
  if ($label.length) $label.text(`${pct}%`);

  if (instant) {
    window.requestAnimationFrame(() => { $bar.css('transition', ''); });
  }
};

// ─── Screen switching ─────────────────────────────────────────────────────────
const showSurveyScreen = ($form, screenName) => {
  $form.find('[data-survey-screen]').each(function toggleScreen() {
    const $el = $(this);
    $el.toggleClass('d-none', $el.data('surveyScreen') !== screenName);
  });

  $form.find('[data-survey-progress]').toggleClass('d-none', screenName === 'greeting');
  $form.closest('[data-has-survey="true"]')
    .find('[data-survey-hide-when-started]')
    .toggleClass('d-none', screenName === 'questions');
};

// ─── Thank-you screen ─────────────────────────────────────────────────────────
const showThankYouScreen = ($form, { instant = false, alreadySubmitted = false } = {}) => {
  updateProgressBar($form, 100, instant);

  const $badge = $form.find('[data-survey-submitted-badge]');
  $badge.toggleClass('d-none', !alreadySubmitted);

  showSurveyScreen($form, 'thank-you');
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

// ─── Required-field gate ───────────────────────────────────────────────────────
const isStepRequiredAndEmpty = ($form, stepIndex) => {
  const $step = $form.find(`[data-survey-step="${stepIndex}"]`);
  const $section = $step.find('[data-required="true"]');
  if (!$section.length) return false;

  const $radiosOrCheckboxes = $section.find('input[type="radio"], input[type="checkbox"]');
  if ($radiosOrCheckboxes.length) return !$radiosOrCheckboxes.is(':checked');

  const $rangeInputs = $section.find('input[type="range"]');
  if ($rangeInputs.length) return !$rangeInputs.is('[data-touched="true"]');

  const $textInputs = $section.find('textarea, input[type="text"], input[type="number"]');
  if ($textInputs.length) return !$textInputs.filter(function hasValue() { return $(this).val().trim() !== ''; }).length;

  return false;
};

const refreshNextBtn = ($form, stepIndex) => {
  const $next = $form.find('[data-survey-action="next"]');
  if (!$next.length) return;
  const blocked = isStepRequiredAndEmpty($form, stepIndex);
  $next.prop('disabled', blocked).toggleClass('disabled', blocked);
};

const updateAnsweredProgress = ($form) => {
  const total = parseInt($form.data('surveySectionCount') || '0', 10);
  if (!total) return;

  const answered = $form.find('[data-survey-step][data-answered="true"]').length;
  updateProgressBar($form, (answered / total) * 100);
};

const markStepAnswered = ($form, input) => {
  const $input = $(input);
  const type = ($input.attr('type') || '').toLowerCase();
  let hasAnswer = false;

  if (type === 'radio' || type === 'checkbox') {
    hasAnswer = $input.closest('[data-survey-step]')
      .find('input[type="radio"]:checked, input[type="checkbox"]:checked')
      .length > 0;
  } else if (type === 'range') {
    hasAnswer = $input.is('[data-touched="true"]');
  } else {
    hasAnswer = String($input.val() || '').trim() !== '';
  }

  if (hasAnswer) {
    $input.closest('[data-survey-step]').attr('data-answered', 'true');
  }

  updateAnsweredProgress($form);
};

// ─── Wizard step navigation ────────────────────────────────────────────────────
const showWizardStep = ($form, stepIndex) => {
  const total = parseInt($form.data('surveySectionCount') || '0', 10);

  $form.find('[data-survey-step]').each(function toggleStep() {
    const $step = $(this);
    $step.toggleClass('d-none', parseInt($step.data('surveyStep'), 10) !== stepIndex);
  });

  const $back = $form.find('[data-survey-action="prev"]');
  $back.css('visibility', stepIndex === 0 ? 'hidden' : 'visible');

  const $next = $form.find('[data-survey-action="next"]');
  const $submit = $form.find('.submit-btn');
  const isLast = stepIndex >= total - 1;
  $next.toggleClass('d-none', isLast);
  $submit.toggleClass('d-none', !isLast);

  $form.find('[data-survey-step-label]').text(`Frage ${stepIndex + 1} von ${total}`);

  $form.data('wizardCurrentStep', stepIndex);
  showSurveyScreen($form, 'questions');
  updateAnsweredProgress($form);
  refreshNextBtn($form, stepIndex);
};

// ─── Wizard initialization ─────────────────────────────────────────────────────
const initSurveyWizard = () => {
  $('.survey-page').closest('form').each(function setupWizard() {
    const $form = $(this);
    if ($form.data('surveySubmitted')) return;

    const total = parseInt($form.data('surveySectionCount') || '0', 10);
    if (!total) return;

    $form.off('change.surveyWizard input.surveyWizard')
      .on('change.surveyWizard input.surveyWizard', 'input, textarea', function onAnswerChange() {
        if ($(this).is('input[type="range"]')) $(this).attr('data-touched', 'true');
        markStepAnswered($form, this);
        refreshNextBtn($form, $form.data('wizardCurrentStep') || 0);
      });

    $form.off('click.surveyWizard').on('click.surveyWizard', '[data-survey-action]', function onNavClick(e) {
      const action = $(this).data('surveyAction');
      if (action === 'start') {
        showWizardStep($form, 0);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if (action === 'next') {
        e.preventDefault();
        const current = $form.data('wizardCurrentStep') || 0;
        showWizardStep($form, Math.min(current + 1, total - 1));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else if (action === 'prev') {
        e.preventDefault();
        const current = $form.data('wizardCurrentStep') || 0;
        if (current > 0) {
          showWizardStep($form, current - 1);
        } else {
          const greetingData = $form.data('surveyGreeting');
          if (greetingData && (greetingData.title || greetingData.text)) {
            updateProgressBar($form, 0);
            showSurveyScreen($form, 'greeting');
          }
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });

    const greetingData = $form.data('surveyGreeting');
    const hasGreeting = greetingData && (greetingData.title || greetingData.text);
    if (!hasGreeting) {
      showWizardStep($form, 0);
    } else {
      updateProgressBar($form, 0);
    }
  });
};

// ─── Share button text ─────────────────────────────────────────────────────────
const updateShareButtonText = () => {
  if (!document.querySelector('[data-has-survey="true"]')) return;
  document.querySelectorAll('.article-share span').forEach((span) => {
    if (span.textContent.trim() === 'Artikel teilen') {
      span.textContent = 'Umfrage teilen';
    }
  });
};

const applyStoredSurveyState = () => {
  $('.survey-page').closest('form').each(function hydrateForm() {
    const $form = $(this);
    const formEl = this;
    const uuid = getSurveyUuid(formEl);
    const tokenIdentifier = getStorageTokenIdentifier(formEl);
    const alreadySubmitted = Boolean($form.data('surveySubmitted'));

    if (!uuid && !alreadySubmitted) {
      return;
    }

    if (alreadySubmitted) {
      markFormAsSubmitted($form);
      showThankYouScreen($form, { instant: true, alreadySubmitted: true });
      return;
    }

    const stored = readStoredSurveySubmission(uuid, tokenIdentifier);
    if (stored && stored.responses) {
      $form.data('surveySubmitted', true);
      markFormAsSubmitted($form);
      showThankYouScreen($form, { instant: true, alreadySubmitted: true });
    } else {
      setStatusMessage($form, '');
      restoreSubmitButton($form);
      hideInlineAlert($form);
    }
  });
};

const handleSurveySubmit = async (event, $form) => {
  const formEl = event.currentTarget;
  if (event.isDefaultPrevented && event.isDefaultPrevented()) {
    return;
  }

  const alreadySubmitted = Boolean($form.data('surveySubmitted'));
  if (alreadySubmitted) {
    markFormAsSubmitted($form);
    showThankYouScreen($form, { instant: false, alreadySubmitted: true });
    event.preventDefault();
    return;
  }

  const uuid = getSurveyUuid(formEl);
  const tokenIdentifier = getStorageTokenIdentifier(formEl);
  const stored = uuid ? readStoredSurveySubmission(uuid, tokenIdentifier) : null;

  if (stored && stored.responses) {
    $form.data('surveySubmitted', true);
    markFormAsSubmitted($form);
    showThankYouScreen($form, { instant: false, alreadySubmitted: true });
    event.preventDefault();
    return;
  }

  if (!uuid) {
    // no uuid means we cannot track; fall back to default submit
    return;
  }

  // Prevent concurrent submissions (rapid double-click / Enter key race)
  if ($form.data('surveySubmitting')) {
    event.preventDefault();
    return;
  }

  event.preventDefault();
  $form.data('surveySubmitting', true);
  setSubmitButtonLoading($form, true);
  setStatusMessage($form, '');
  hideInlineAlert($form);

  const pushToken = getPushTokenFromForm(formEl);
  const authenticityToken = getAuthenticityTokenFromForm(formEl);

  const ortInput = formEl.querySelector('input[name="ort"]');
  const ortValue = ortInput && ortInput.value ? parseInt(ortInput.value, 10) : undefined;

  try {
    const jsonPayload = { uuid, responses: buildSurveyResponses($form) };
    if (pushToken) jsonPayload.push_token = pushToken;
    if (ortValue !== undefined && !Number.isNaN(ortValue)) jsonPayload.ort = ortValue;

    const action = $form.attr('action') || '/surveys';
    const method = ($form.attr('method') || 'post').toUpperCase();

    const response = await fetch(action, {
      method,
      body: JSON.stringify(jsonPayload),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': getCsrfToken(),
        Accept: 'application/json',
      },
      credentials: 'same-origin',
    });

    const payload = await response.clone().json().catch(() => ({}));
    if (!response.ok || (payload.status && payload.status !== 'ok')) {
      const errorMessage = payload.message ||
        'Die Umfrage konnte nicht gesendet werden. Bitte versuche es erneut.';
      throw new Error(errorMessage);
    }

    const responses = collectResponsesForStorage(formEl);
    storeSurveySubmission(uuid, tokenIdentifier, responses, { authenticityToken });
    $form.data('surveySubmitted', true);
    applySavedResponses(formEl, responses);
    markFormAsSubmitted($form);
    showThankYouScreen($form, { instant: false, alreadySubmitted: false });
  } catch (error) {
    setStatusMessage($form, error.message || 'Unbekannter Fehler', 'error');
    showInlineAlert($form, error.message || 'Die Umfrage konnte nicht gesendet werden.', 'error');
    scrollToInlineAlert($form);
  } finally {
    $form.data('surveySubmitting', false);
    if (!$form.data('surveySubmitted')) {
      restoreSubmitButton($form);
    }
  }
};

const initSurveySubmissionHandling = () => {
  $('.survey-page').closest('form').each(function bindSubmit() {
    const $form = $(this);
    $form.off('submit.surveySubmit').on('submit.surveySubmit', function onSubmit(event) {
      handleSurveySubmit(event, $form);
    });
  });
};

const initSurveyInteractions = () => {
  if (!$('.survey-page').length) {
    return;
  }

  applyStoredSurveyState();
  initSurveyWizard();
  updateShareButtonText();
  initNpsScale();
  initStars();
  initEmojis();
  initEmojiSelections();
  initSliders();
  initRanking();
  initImageOptions();
  initNpsSelections();
  initChoiceOptionClicks();
  initMatrixSelections();
  // Validation must be bound before submission so it runs first on the submit event.
  initClientValidation();
  initSurveySubmissionHandling();
  scrollToPrerenderedErrors();
};

// Capture-phase document listener — fires before Turbo and before jQuery bubble handlers.
// Acts as a guaranteed fallback if element-level binding via initClientValidation fails.
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form || !form.querySelector('.survey-page')) return;

  const $form = $(form);
  if ($form.data('surveySubmitted')) return;

  const invalid = validateRequiredSections($form);
  if (invalid.length) {
    event.preventDefault();
    event.stopImmediatePropagation();
    scrollToFirstInvalidSection($form);
  }
}, true); // capture = true → runs before everything else

document.addEventListener('turbo:load', initSurveyInteractions);
document.addEventListener('turbo:render', initSurveyInteractions);
document.addEventListener('turbo:frame-load', initSurveyInteractions);
document.addEventListener('DOMContentLoaded', initSurveyInteractions);
document.addEventListener('turbo:after-stream-render', scrollToVisibleInlineAlert);
document.addEventListener('turbo:submit-end', scheduleScrollToVisibleAlert);
